import React from 'react'
import TransactionType from '../../elements/TransactionType'

const SundryTransactionDetails = ({transaction}) => {
  return (
     <div className='w-full p-[10px]'>
          <div className='my-[20px]'>
            <label className='text-xs text-gray-400 font-[550] block mb-[5px]'>Reference</label>
            <p className='font-space-grotesk font-[500] tracking-[0.2em]'>{transaction?.reference}</p>
          </div>
          <div className='my-[20px]'>
            <label className='text-xs text-gray-400 font-[550] block mb-[5px]'>Recorded by</label>
            <p className='font-[500] text-sm'>{transaction?.recordedBy?.name || <div className='h-[14px] w-[120px] bg-gray-100 animate-pulse' />}</p>
          </div>
          <div className='my-[20px]'>
            <label className='text-xs text-gray-400 font-[550] block mb-[5px]'>Remarks</label>
            <p className='font-[500] text-sm'>{transaction?.remarks || <span className='text-gray-400'>No remarks</span>}</p>
          </div>
          <div className='my-[20px]'>
            <label className='text-xs text-gray-400 font-[550] block mb-[5px]'>Amount</label>
            <div className='flex items-center gap-x-2'>
              <p className='font-space-grotesk font-[600] text-xl tracking-[0.2em]'>₦{(transaction?.amount/100).toLocaleString()}</p>
              <TransactionType type={transaction?.type} />
            </div>
          </div>

          {transaction.type === 'charge' && transaction.items && transaction.items.length > 0 &&
            <div className='p-[10px] bg-gray-50 rounded-[8px]'>
              <h4 className='font-[500] text-xs mb-[5px] uppercase tracking-[0.2em]'>Transaction Items</h4>
              {transaction.items.map(item => (
                <div key={item.id} className='flex justify-between py-[10px] border-t border-gray-200'>
                  <p className='font-[500] text-sm'>{item.item.itemName} (x{item.quantity})</p>
                  <p className='font-[500] text-sm font-space-grotesk'>₦{(item.amount).toLocaleString()}</p>
                </div>
              ))}
            </div>
          }
        </div>
  )
}

export default SundryTransactionDetails